/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_TitleInputs */

const cs_property_ai_title = /** @type {(inputs: Property_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog a AI fotek`)
};

const en_property_ai_title = /** @type {(inputs: Property_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalog & image AI`)
};

/**
* | output |
* | --- |
* | "Catalog & image AI" |
*
* @param {Property_Ai_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_title = /** @type {((inputs?: Property_Ai_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_title(inputs)
	return cs_property_ai_title(inputs)
});